import { Fragment } from "react";
import { createPage } from "../../shared/components/PageBase";

export const Home = createPage(() => {

    return <Fragment>Home</Fragment>;
}, "Home")
